import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exitMarkFF534A",
  "use": "exitMarkFF534A-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"exitMarkFF534A\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12z\" fill=\"#FF534A\" /><path d=\"M7.885 4.113L4.137 7.861M4.113 4.113l3.748 3.748\" stroke=\"#fff\" stroke-width=\".85\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol